import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { RowItem } from '../../models';

@Component({
    selector: 'app-collapsable-wrapper',
    templateUrl: './collapsable-wrapper.component.html',
    styleUrls: ['./collapsable-wrapper.component.scss'],
    standalone: false
})
export class CollapsableWrapperComponent implements OnInit , AfterViewInit {

  @Input() title: string;
  @Input() icon: string;
  @Input() isSticky : boolean = true;
  @ViewChild('top') top: ElementRef;

  rowItems: RowItem[] = [];
  opened = true;

  constructor() { }

  ngOnInit() { }
  ngAfterViewInit() {
    if (this.isSticky){
      const el = document.getElementById('sticky');
      this.top.nativeElement.style.top = el ? el.offsetHeight + 'px' : null;  
    }
  }
}
